module.exports = __webpack_public_path__ + "img/icon-notify.c1379468.svg";